module.exports = __webpack_public_path__ + "static/img/rakuten_s.8f59b02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ribenurl/rakuten_s.jpg
// module id = QIQ5
// module chunks = 23